import type { TemplateTimeSlot } from "@/pages/human-resources/time-management/business/time-slot/TemplateTimeSlot.ts";
import { immerable, produce } from "immer";

export class ScheduleTemplate {
  [immerable] = true;
  constructor(
    public readonly id: string | undefined,
    public readonly domainId: string,
    public readonly timeSlots: TemplateTimeSlot[],
    public readonly label: string,
    public readonly comment?: string,
    public readonly siteId?: string,
    public readonly nbMeals = 0,
    public readonly color?: string,
  ) {}

  public static create(domainId: string, siteId: string): ScheduleTemplate {
    return new ScheduleTemplate(undefined, domainId, [], "", undefined, siteId);
  }

  public isInvalid(): boolean {
    return (
      this.timeSlots.length == 0 ||
      this.timeSlots.some((ts) => ts.invalid()) ||
      this.timeSlots.some((ts) => ts.overlapsAnyOf(this.timeSlots))
    );
  }

  public withTemplatableSlotsOnly(): ScheduleTemplate {
    return produce<ScheduleTemplate>(this, (draft) => {
      draft.timeSlots = this.timeSlots.filter((s) => s.canAppearInTemplate());
    });
  }
}
